class CartUpsell extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			countdown: 'countdown',
			addToCartForm: 'add-to-cart-form',
		};

		this.elements = {
			countdown: document.getElementById(this.selectors.countdown),
			minutes: countdown.dataset.minutes,
			addToCartForm: document.getElementById(this.selectors.addToCartForm),
		};

		this.init();
	}

	async init() {
		this.startCountdown();
		this.destroyElement();
	}

	lessThan24Hours(date) {
		const now = new Date().getTime();
		const oldDate = new Date(date).getTime();
		const difference = now - oldDate;

		if (difference < 86400000) {
			return true;
		} else {
			return false;
		}
	}

	startCountdown() {
		this.setCartAttributes({
			date: new Date(),
			destroyed: true,
		});

		const countdown = document.getElementById('countdown');
		const duration = this.elements.minutes * 60;
		const interval = 1000;
		const endTime = Date.now() + duration * 1000;
		const countdownInterval = setInterval(updateCountdown, interval);

		function updateCountdown() {
			const remainingTime = Math.round((endTime - Date.now()) / 1000);

			if (remainingTime < 0) {
				clearInterval(countdownInterval);
				this.elements.countdown.textContent = '0:00';
			} else {
				const minutes = Math.floor(remainingTime / 60);
				const seconds = remainingTime % 60;
				const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
				countdown.textContent = formattedTime;
			}
		}
	}

	async destroyElement() {
		const destroyIn = this.elements.minutes * 1000 * 60;
		setTimeout(() => {
			this.remove();
		}, destroyIn);
	}

	async getCartData() {
		const response = await fetch('/cart.js');
		const data = await response.json();

		return data;
	}

	async setCartAttributes(attributes = {}) {
		console.log(attributes);
		const result = await fetch('/cart/update.json', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({
				attributes: attributes,
			}),
		});

		return result.json();
	}
}
customElements.define('cart-upsell', CartUpsell);
